import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { request } from '@/store/helper';
import { AlertsState, Alert } from '@/types'; // Import types

// **Initial State**
const initialState: AlertsState = {
  alerts: [],
  count: null,
  status: 'idle',
  reminder: null,
};

// **Thunks**
export const alertsGet = createAsyncThunk<
  Alert[], // Success type
  void, // Argument type
  { rejectValue: string } // Error type
>('alerts/get', async (_, { rejectWithValue }) => {
  const response = await request('admin/debug');
  return response.success ? response.data : rejectWithValue(response.error || 'Failed to fetch alerts');
});

export const alertsGetUnreadCount = createAsyncThunk<
  number, // Success type
  void, // Argument type
  { rejectValue: string } // Error type
>('alerts/getUnreadCount', async (_, { rejectWithValue }) => {
  const response = await request('admin/unread-count');
  return response.success ? response.data : rejectWithValue(response.error || 'Failed to fetch unread count');
});

// **Slice**
const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    const setLoading = (state: AlertsState) => {
      state.status = 'loading';
    };

    const setFailed = (state: AlertsState) => {
      state.status = 'failed';
    };

    // Fetch Alerts
    builder
      .addCase(alertsGet.pending, setLoading)
      .addCase(alertsGet.fulfilled, (state, { payload }) => {
        state.alerts = payload;
        state.status = 'success';
      })
      .addCase(alertsGet.rejected, setFailed);

    // Get Unread Count
    builder.addCase(alertsGetUnreadCount.fulfilled, (state, { payload }) => {
      state.count = payload;
    });
  },
});

// **Export Reducer**
export default alertsSlice.reducer;